import { Component, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CfHomeService } from '../service/cf-home.service';
import { Router, RouterModule } from '@angular/router';
import { TranslateService ,TranslateModule} from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';
export interface Product {
  item: string;
  Images: string[]; // Correctly representing the array of image URLs
  public: boolean;
}
@Component({
  selector: 'app-search-bar',
  standalone: true,
  imports: [CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    FeatherModule],
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent {
 constructor(private cfHomeService : CfHomeService,
    private router: Router,
    private elementRef: ElementRef

  ){
    this.getProducts();
  }
  searchQuery: string = '';
  filteredProducts: any[] = [];
  selectedIndex: number | null = null;
  products :Product[] = [];
  optionHidden: boolean = false;

  getProducts() {
    this.cfHomeService.SearchProductList().subscribe(
      (data: Product[]) => {
        this.products = data;
      }
    );
  }

  filterProducts() {
    this.optionHidden = false;
    const query = this.searchQuery.toLowerCase();
    if (query.length === 0) {
      this.filteredProducts = [];
      this.selectedIndex = null;
    } else {
      this.filteredProducts = this.products.filter((product) =>
        product.item.toLowerCase().includes(query)
      );

    }
  }

  selectProduct(index: number, link: string) {
    this.selectedIndex = index;
    this.navigateToProduct(index,link);
  }

  navigateToProduct(index: number,id: string): void {
      this.selectedIndex = index;
    this.optionHidden = true;
    const link = `/product-list/${id}`;
    this.router.navigate([link]);
  }

  getDefaultImage(images: any[]): string {
    const defaultImage = images.find(image => image.default_image);
    return defaultImage ? defaultImage.image_preview : 'assets/images/default.jpg';
  }
 // Listen for clicks outside the component
 @HostListener('document:click', ['$event'])
 onDocumentClick(event: Event): void {
   if (!this.elementRef.nativeElement.contains(event.target)) {
     this.closeSearchResults();
   }
 }

 // Method to close search results and clear input
 closeSearchResults(): void {
   this.optionHidden = true;
   this.searchQuery = '';
   this.filteredProducts = [];
   this.selectedIndex = null;
 }
}
